import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=62f2b03c"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f2b03c')) {
      api.createRecord('62f2b03c', component.options)
    } else {
      api.reload('62f2b03c', component.options)
    }
    module.hot.accept("./LoadingPage.vue?vue&type=template&id=62f2b03c", function () {
      api.rerender('62f2b03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Default-Page-Components/modules/LoadingPage.vue"
export default component.exports